import { useState } from 'react';
import style from './userListings.module.css';
import { Link } from 'react-router-dom';
import { Form, FormControl } from 'react-bootstrap';
import { IoMdSearch } from "react-icons/io";
import GridViewGrey from '../../../assets/images/GridviewGrey.svg';
import ListViewGrey from '../../../assets/images/ListviewGrey.svg';
import GridviewGreen from '../../../assets/images/GridviewGreen.svg';
import ListViewGreen from '../../../assets/images/ListviewGreen.svg';
import BuyerGridView from '../../../components/buyerListing/BuyergridView';
import BuyerTableView from '../../../components/buyerListing/BuyerTableView';

const BuyerListings = ({BuyerData}) => {
    const [ShowGridView, setShowGridView] = useState(false);
    const [SearchValue, setSearchValue] = useState('')
    return (
        <div>
            <div className="row mt-4">
                <div className="col-md-12">
                    <div className={style.filterWrapper + ' ' + 'row'}>
                        <div className="col-md-4">
                            <Form>
                                <div className={style.search}>
                                    <FormControl
                                        placeholder="Search for any data..."
                                        onChange={(e)=>setSearchValue(e.target.value)}
                                    />
                                    <IoMdSearch />
                                </div>
                            </Form>
                        </div>
                        <div className={style.filterView + ' ' + 'col-md-8 text-end'}>
                            <Link onClick={()=>setShowGridView(true)}>
                                <img 
                                  src={ShowGridView===true?GridviewGreen:GridViewGrey} 
                                  alt="Grid View" 
                                  style={{
                                      backgroundColor:ShowGridView===true?"#DFDFDF":"unset",
                                    }}
                                />
                            </Link>
                            <Link onClick={()=>setShowGridView(false)}>
                                <img 
                                  src={ShowGridView===true?ListViewGrey:ListViewGreen} 
                                  alt="List View" 
                                  style={{backgroundColor:ShowGridView===true?"unset":"#DFDFDF"}}
                                />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    {ShowGridView?
                    <BuyerGridView 
                        BuyerDataset={BuyerData}
                        searchInput={SearchValue}
                    />:
                    <BuyerTableView
                        BuyerDataset={BuyerData}
                        searchInput={SearchValue}
                    />}
                </div>
            </div>
        </div>
    )
}

export default BuyerListings